import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import InputModalLabel from 'common/components/Elements/Form/InputModalLabel/InputModalLabel';
import { generateRandomString } from 'common/utilities/core/string';
import type { ValueLabelOption } from 'core/utilities/core.types';
import React, { useState } from 'react';

import classes from './InputCheckboxGroup.style';

export interface ComponentProps {
  label?: string;
  onChange: (value: string, checked: boolean) => void;
  e2eId?: string;
  options: ValueLabelOption[];
  values: string[];
  modalLabel?: boolean;
}

function InputCheckboxGroup({
  label, values, options, onChange, e2eId, modalLabel,
}: ComponentProps) {
  const [id] = useState(() => generateRandomString());

  return (
    <Box pl={0.5}>
      <FormControl
        component="fieldset"
        data-e2e-form-radio-group={e2eId}
        aria-labelledby={id}
      >
        {label && (
          <FormLabel
            id={id}
            component="legend"
            sx={classes.label}
          >
            {modalLabel ? (
              <InputModalLabel>{label}</InputModalLabel>
            ) : label}
          </FormLabel>
        )}
        <FormGroup>
          {options.map((option) => {
            const checked = values.includes(option.value);

            return (
              <FormControlLabel
                key={option.value}
                control={(
                  <Checkbox
                    checked={checked}
                    onChange={() => onChange(option.value, checked)}
                    value={option.value}
                    color="primary"
                    sx={classes.checkbox}
                  />
                )}
                label={option.label}
              />
            );
          })}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export default InputCheckboxGroup;

